//get-rejected-riders
import React, { useEffect, useState, useRef } from "react";

import {
  Col,
  Card,
  Table,
  Dropdown,
  Alert,
  Spinner,
  Badge,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function RejectedRiders() {
  var history = useHistory();
  const [data, setData] = useState([]);
  const sort = 10;
  const activePag = useRef(0);

  const [riders, setRiders] = useState([]);
  const [searchData, setSearchData] = useState([]);

  const [spinner, setSpinner] = useState(true);
  const [test, settest] = useState(0);
  function getData() {
    axios
      .get(Baseurl.baseurl + "/rider/get-rejected-riders")
      .then((res) => {
        setSpinner(false);
        setRiders(res.data.riders.reverse());
        setSearchData(res.data.riders);
        setData(document.querySelectorAll("#job_data tbody tr"))
      })
      .catch((err) => {
        //   if(err.toString()==="Error: Network Error")
        //   {
        //     history.push('/offline')
        //   }
        //   else
        //   {
        //     history.push('/400')
        //   }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    if (searchData) {
      searchData.map((val) => {
        let phoneString = val.riderPhone.toString();
        if (
          val.riderFirstName.toLowerCase().includes(value) ||
          val.riderLastName.toLowerCase().includes(value) ||
          val.riderEmail.toLowerCase().includes(value) ||
          phoneString.includes(value)
        ) {
          filteredData.push(val);
        }
      });
      setRiders(filteredData);
    }
  }

  return (
    <Col lg={12}>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          {/* {onlineFlag?( <button className="btn btn-primary" onClick={()=>{
            setOnlineFlag(false)
            getData()
            }}>All</button>):( <button className="btn btn-primary" onClick={()=>{getOnlineRider()}}>Online</button>)} */}
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>
                    {/* <th>
                      <strong>Profile</strong>
                    </th> */}
                    <th>
                      <strong>RIDER NAME</strong>
                    </th>
                    <th>
                      <strong>Rider Id</strong>
                    </th>
                    <th>
                      <strong>Phone No.</strong>
                    </th>
                    <th>
                      <strong>status</strong>
                    </th>
                    <th>
                      <strong>Vehicle</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {riders &&
                    riders.map((rider, key) => (
                      <tr key={rider._id}>
                        <td>{key + 1}</td>
                        {/* <td>
                          <div className="profile-photo">
                            <img
                              src={`${Baseurl.baseurl}/uploads/images/${rider.riderProfileImage}`}
                              className="img-fluid rounded-circle"
                              alt="profile"
                            />
                          </div>
                        </td> */}
                        <td>
                          <div className="d-flex align-items-center">
                            <img
                              src={rider.riderProfileImage}
                              className="rounded-lg mr-2"
                              width={40}
                              height={40}
                              alt=""
                            />{" "}
                            <span className="w-space-no">
                              {rider.riderFirstName} {rider.riderLastName}
                            </span>
                          </div>
                        </td>
                        <td>{rider._id}</td>
                        <td>{rider.riderPhone}</td>
                        <td>
                          {rider.Online ? (
                            <div className="d-flex align-items-center">
                              <i className="fa fa-circle text-success mr-1"></i>{" "}
                              Online
                            </div>
                          ) : (
                            <div className="d-flex align-items-center">
                              <i className="fa fa-circle text-danger mr-1 "></i>
                              Offline
                            </div>
                          )}
                        </td>
                        <td>{rider.RiderVehicleType.name}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push(`./rider-details/Rejected/${rider._id}`);
                                }}
                              >
                                View
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                        <td>
                          <Link to={`./edit-rider/Rejected/${rider._id}`}>
                            <button className="btn btn-primary">Edit</button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!riders && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero riders
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default RejectedRiders;
